export default __webpack_public_path__ + "static/img_howitworks-0fb7fdf1e9ca3e26fb99fa060389b11f.svg";